(function () {
  const T = window.theme || { routes: {} };
  const root = (T.routes && T.routes.root) || '/';
  const drawer = () => document.getElementById('CartDrawer');

  function toast(msg) {
    let el = document.querySelector('.ff-toast');
    if (!el) { el = document.createElement('div'); el.className = 'ff-toast'; document.body.appendChild(el); }
    el.textContent = msg; el.classList.add('is-show');
    clearTimeout(el._t); el._t = setTimeout(() => el.classList.remove('is-show'), 2200);
  }
  function openDrawer() { const d = drawer(); if (!d) return; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { const d = drawer(); if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  async function refreshCart() {
    const cart = await fetch(root + 'cart.js').then(r => r.json());
    const count = document.getElementById('CartCount');
    if (count) { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; }
    const page = await fetch(root + 'cart?view=drawer').then(r => r.ok ? r.text() : null).catch(() => null);
    const src = page;
    if (src) {
      const doc = new DOMParser().parseFromString(src, 'text/html');
      const body = doc.getElementById('CartDrawerBody');
      const total = doc.getElementById('CartDrawerTotal');
      if (body) document.getElementById('CartDrawerBody').innerHTML = body.innerHTML;
      if (total) document.getElementById('CartDrawerTotal').textContent = total.textContent;
      const btn = document.querySelector('#CartDrawer button[name="checkout"]');
      if (btn) btn.disabled = cart.item_count === 0;
    }
    return cart;
  }

  // Add to cart (cards + product form)
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.js-add-form');
    if (!form || T.cartType === 'page') return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    try {
      const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok) { toast(data.description || data.message || 'Could not add'); return; }
      await refreshCart(); toast('Added to cart!'); openDrawer();
    } catch (err) { toast('Something went wrong'); }
    finally { if (btn) btn.disabled = false; }
  });

  // Quantity changes in cart
  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-qty-change]');
    if (q) {
      const onCartPage = !!document.getElementById('CartPage');
      const d = drawer(); d && d.classList.add('is-loading');
      await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +q.dataset.line, quantity: +q.dataset.qtyChange }) });
      if (onCartPage && !q.closest('#CartDrawer')) { location.reload(); return; }
      await refreshCart(); d && d.classList.remove('is-loading'); return;
    }
    if (e.target.closest('[data-cart-open]') && T.cartType !== 'page' && drawer()) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    const m = e.target.closest('[data-menu-toggle]');
    if (m) { const nav = document.getElementById('HeaderNav'); const open = nav.classList.toggle('is-open'); m.setAttribute('aria-expanded', open); return; }
    const step = e.target.closest('[data-qty-step]');
    if (step) { const inp = step.parentElement.querySelector('input'); inp.value = Math.max(1, (+inp.value || 1) + +step.dataset.qtyStep); return; }
    const thumb = e.target.closest('[data-thumb]');
    if (thumb) { const main = document.getElementById('MainImage'); if (main) { main.src = thumb.dataset.thumb; main.removeAttribute('srcset'); } document.querySelectorAll('.thumb').forEach(t => t.classList.toggle('is-active', t === thumb)); return; }
    const code = e.target.closest('[data-copy]');
    if (code && navigator.clipboard) { navigator.clipboard.writeText(code.dataset.copy); toast('Code copied!'); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  // Variant picker: Liquid renders product.selected_or_first_available_variant.
  // JS only reacts to option changes and trusts Shopify's variant.available.
  const section = document.querySelector('[data-product-section]');
  const vjson = section && section.querySelector('[data-variants-json]');
  const form = section && section.querySelector('#ProductForm');
  if (vjson && form && form.querySelector('[data-option-index]')) {
    const variants = JSON.parse(vjson.textContent || '[]');
    const btn = section.querySelector('[data-add-btn]');
    const idInput = form.querySelector('[data-variant-id]');
    const money = (c) => (c / 100).toLocaleString(document.documentElement.lang || 'en-GB', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' });
    const optionCount = variants[0] ? variants[0].options.length : 0;
    const match = (sel) => variants.find((v) => v.options.every((o, i) => o === sel[i]));
    const selected = () => Array.from({ length: optionCount }, (_, i) => {
      const c = form.querySelector('input[data-option-index="' + i + '"]:checked'); return c ? c.value : null;
    });
    const markChips = (sel) => form.querySelectorAll('.opt__chip input').forEach((inp) => {
      const t = sel.slice(); t[+inp.dataset.optionIndex] = inp.value;
      const v = match(t); inp.parentElement.classList.toggle('is-unavailable', !v || !v.available);
    });
    const update = () => {
      const sel = selected();
      markChips(sel);
      const v = match(sel);
      const ok = !!(v && v.available);
      if (v) idInput.value = v.id;
      btn.disabled = !ok;
      btn.textContent = ok ? btn.dataset.labelAdd : btn.dataset.labelSold;
      if (!v) return;
      const p = section.querySelector('[data-price]'); if (p) p.textContent = money(v.price);
      const c = section.querySelector('[data-compare]'); if (c) c.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
      const stock = section.querySelector('[data-stock]');
      if (stock) {
        const s = !v.available ? 'sold_out' : v.backorder ? 'backorder' : 'in_stock';
        const label = s === 'sold_out' ? btn.dataset.labelSold : s === 'backorder' ? btn.dataset.labelBack : btn.dataset.labelIn;
        stock.innerHTML = '<span class="stock-badge stock-badge--' + s + '"><span class="stock-badge__dot"></span>' + label + '</span>';
      }
      if (v.image) { const main = document.getElementById('MainImage'); if (main) { main.src = v.image; main.removeAttribute('srcset'); } }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    form.addEventListener('change', (e) => { if (e.target.dataset.optionIndex !== undefined) update(); });
    markChips(selected());
  }

  // Collection filters / sort auto-submit
  const filters = document.getElementById('CollectionFilters');
  if (filters) filters.addEventListener('change', () => filters.submit());
})();
